export default __webpack_public_path__ + "static/media/pricing.f176a14f.png";